import Container from "./components/Container";
import Button from "./components/Button";
import Footer from "./components/Footer";
import styles from "./AdminShell.module.css";

export default function AdminShell({ title, onLogout, children }) {
  return (
    <div>
      <header className={styles.bar}>
        <span className={styles.brand}>
          <span className={styles.dot} aria-hidden="true" /> Urban Services
          <span className={styles.tag}>Admin</span>
        </span>
        {onLogout && (
          <Button variant="ghost" onClick={onLogout} className={styles.logout}>
            Log out
          </Button>
        )}
      </header>
      <main className={styles.main}>
        <Container>
          <h1 className={styles.title}>{title}</h1>
          {children}
        </Container>
      </main>
      <Footer />
    </div>
  );
}
